import React from 'react';
import { conflitosText, siteConfig } from '../../data/mock';
import { MessageCircle, ArrowRight } from 'lucide-react';

const ConflitosSection = () => {
  const whatsappLink = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(siteConfig.whatsappMessage)}`;

  return (
    <section className="py-24 bg-[#2a2523] relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#c9a962]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#c9a962]/5 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-8 leading-tight">
          Conflitos societários <span className="text-[#c9a962]">não se resolvem sozinhos.</span>
        </h2>
        
        {/* Paragraphs */}
        <div className="space-y-6 mb-10">
          {conflitosText.paragraphs.map((text, index) => (
            <p key={index} className="text-xl text-neutral-400 leading-relaxed">
              {text}
            </p>
          ))}
        </div>
        
        {/* CTA Text */}
        <p className="text-[#c9a962] text-lg font-medium mb-6">
          {conflitosText.cta}
        </p>
        
        {/* CTA Button */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center justify-center gap-3 bg-emerald-600 hover:bg-emerald-500 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-emerald-500/25"
        >
          <MessageCircle className="w-5 h-5" />
          {siteConfig.ctaText}
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </section>
  );
};

export default ConflitosSection;
